module.exports = __webpack_public_path__ + "img/summary_background_AP_mobile_portrait.4ba07a0b.jpg";